module.exports = __webpack_public_path__ + "media/images/logo-mobile-addcf58f9da8b3577bec0391669a2694.svg";